const API_BASE_PATH = process.env.REACT_APP_DOMAIN_API;
const API_ADMIN_PATH = `${API_BASE_PATH}front/`;

const API_PATH = {
  login: `${API_ADMIN_PATH}login/account`,
  loginWithSMS: `${API_ADMIN_PATH}login/account-with-sms`,
  logout: `${API_ADMIN_PATH}user/logout`,
  register: `${API_ADMIN_PATH}register/account`,
  verify: `${API_ADMIN_PATH}verify/account`,
  verifyChangePass: `${API_ADMIN_PATH}verify/account-change-pass`,
  getOTP: `${API_ADMIN_PATH}otp/account`,
  requestOtpPackage: `${API_ADMIN_PATH}otp/request-otp-package`,
  verifyOtpPackage: `${API_ADMIN_PATH}otp/verify-otp-package`,
  registerMytelPack: `${API_ADMIN_PATH}user/register-pack`,
  getUser: `${API_ADMIN_PATH}user/current`,
  getBidHistory: `${API_ADMIN_PATH}user/bid-history`,
  getPackageList: `${API_ADMIN_PATH}user/list-package`,
  getRemainTurn: `${API_ADMIN_PATH}user/remain-turn`,
  updatePassword: `${API_ADMIN_PATH}user/update-password`,
  updateInformation: `${API_ADMIN_PATH}user/update-information`,
  viewInfoWinner: `${API_ADMIN_PATH}user/view-info-winner`,

  crossBanner: `${API_ADMIN_PATH}cross-banner`,
  crossIcons: `${API_ADMIN_PATH}cross-icons`,

  bidProduct: `${API_ADMIN_PATH}product/bid`,
  upNextProduct: `${API_ADMIN_PATH}product/up-next`,
  finishedProduct: `${API_ADMIN_PATH}product/finished`,
  resultsProduct: `${API_ADMIN_PATH}product/results`,
  viewPotentialWinner: `${API_ADMIN_PATH}product/view-potential-winner`,
  bestSeller: `${API_ADMIN_PATH}product/best-seller`,
  banner: `${API_ADMIN_PATH}product/banner`,

  bid: `${API_ADMIN_PATH}bid`,
  bidHistory: `${API_ADMIN_PATH}bid/history`,
  bidHistoryAll: `${API_ADMIN_PATH}bid/history-all`,
  packs: `${API_ADMIN_PATH}bid/packs`,
  registerPack: `${API_ADMIN_PATH}bid/register`,
  shweHourBidCount: `${API_ADMIN_PATH}bid/shwe-hour-bid`,

  upload: `${API_BASE_PATH}upload`,

  getGameInfo: `${API_ADMIN_PATH}game/lucky-spin/info`,
  getMonthWinner: `${API_ADMIN_PATH}product/month-winner`,

  getSocialIcons: `${API_ADMIN_PATH}social-icons`,
  // event
  configEvent: `${API_ADMIN_PATH}lighting/check-status`,
  lanternCollection: `${API_ADMIN_PATH}lighting/get-statistic`,
  spinLuckyMoon: `${API_ADMIN_PATH}lucky-moon/lucky-moon-spin/start-spin`,
  getRankLighting: `${API_ADMIN_PATH}lighting/get-rank-lighting`,
  historySpinLuckyMoon: `${API_ADMIN_PATH}lucky-moon/lucky-moon-spin/history`,
  pairing: `${API_ADMIN_PATH}lighting/pairing`,
  // event new year and Noel 2024
  newYearConfigEvent: `${API_ADMIN_PATH}new-year/check-status`,
  newYearGetStatistic: `${API_ADMIN_PATH}new-year/get-statistic`,
  newYearGetRank: `${API_ADMIN_PATH}new-year/get-rank-new-year`,
  newYearPairing: `${API_ADMIN_PATH}new-year/pairing`,
  noelHistory: `${API_ADMIN_PATH}noel/history`,
  noelHistorySpecial: `${API_ADMIN_PATH}noel/history-special`,
  noelStartOpen: `${API_ADMIN_PATH}noel/start-open`,
  newYearUserCode: `${API_ADMIN_PATH}new-year/user-code`,
  newYearCodeDetail: `${API_ADMIN_PATH}new-year/code-detail`,
  newYearReceiveCode: `${API_ADMIN_PATH}new-year/receive-code`,
  newYearRank: `${API_ADMIN_PATH}new-year/get-rank-new-year`,
  // event thingyan 2025
  thingyanConfigEvent: `${API_ADMIN_PATH}blessing-reel/check-status`,
  thingyanMissions: `${API_ADMIN_PATH}blessing-reel/missions`,
  thingyanChangeAttemptByBid: `${API_ADMIN_PATH}blessing-reel/change-attempt-by-bid`,
  thingyanPlayLoto: `${API_ADMIN_PATH}blessing-reel/play`,
  thingyanReelAwardList: `${API_ADMIN_PATH}blessing-reel/reel-award-list`,
  thingyanPieceCollected: `${API_ADMIN_PATH}blessing-reel/piece-collected`,
  thingyanPrizeCollection: `${API_ADMIN_PATH}blessing-reel/prize-collection`,
  thingyanTakePrize: `${API_ADMIN_PATH}blessing-reel/take-prize`,
  thingyanWinnerList: `${API_ADMIN_PATH}blessing-reel/list-winner`,
  thingyanReelHistory: `${API_ADMIN_PATH}blessing-reel/reel-history`,
  // Mini Game
  miniGamePlayLoto: `${API_ADMIN_PATH}mini-game/play`,
  miniGamePlayLotoMultiple: `${API_ADMIN_PATH}mini-game/play-multiple`,
  miniGameConfig: `${API_ADMIN_PATH}mini-game/get-mini-game`,
  miniGameGetSpinAward: `${API_ADMIN_PATH}mini-game/get-spin-award`,
  miniGameGetSpinUser: `${API_ADMIN_PATH}mini-game/get-spin-user`,

  miniGameAwardList: `${API_ADMIN_PATH}mini-game/get-award-list`,
  miniGamePieceCollected: `${API_ADMIN_PATH}mini-game/piece-collected`,
  miniGameHistory: `${API_ADMIN_PATH}mini-game/get-mini-game-history`,
  miniGameMissions: `${API_ADMIN_PATH}mini-game/missions`,
  miniGameChangeAttempById: `${API_ADMIN_PATH}mini-game/change-attempt-by-bid`,
  miniGamePrizeCollection: `${API_ADMIN_PATH}mini-game/prize-collection`,
  miniGameTakePrize: `${API_ADMIN_PATH}mini-game/take-prize`,
  miniGameLisWinner: `${API_ADMIN_PATH}mini-game/list-winner`,
  miniGameSpinHistory: `${API_ADMIN_PATH}mini-game/spin-history`,
  miniGameAddPieceLink: `${API_ADMIN_PATH}mini-game/add-piece-link`,
  miniGameConfirmPieceLink: `${API_ADMIN_PATH}mini-game/confirm-piece-link`,
  miniGameAddInviteLink: `${API_ADMIN_PATH}mini-game/add-invite-link`,
  miniGameReceiveInviteLink: `${API_ADMIN_PATH}mini-game/receive-invite-link`,
  miniGameGetCodePieceLinkInfo: `${API_ADMIN_PATH}mini-game/get-code-piece-link-info`, //api Lấy thông tin của code, link tặng/xin mảnh ghép
  miniGameRanking: `${API_ADMIN_PATH}mini-game/get-ranking`,
  miniGameReceivePieceLink: `${API_ADMIN_PATH}mini-game/receive-piece-link`,
  miniGameSendPieceLink: `${API_ADMIN_PATH}mini-game/send-piece-link`,
  enterReferralFriend: `${API_ADMIN_PATH}mini-game/enter-referral-friend`,
  miniGameGetCodeInviteLinkInfo: `${API_ADMIN_PATH}mini-game/get-code-invite-link-info`,
  miniGameDeleteReceiveGive: `${API_ADMIN_PATH}mini-game/delete-receive-give`,
  miniGameInviteRanking: `${API_ADMIN_PATH}mini-game/invite-ranking`,
  miniGameWinnerInviteRanking: `${API_ADMIN_PATH}mini-game/winner-invite-ranking`,
  miniGameGetRule: `${API_ADMIN_PATH}mini-game/get-rule`,

  advertisement: `${API_ADMIN_PATH}product/popup`,
  setPU4NeverShow: `${API_ADMIN_PATH}user/dismiss-intro`,
  increaseCoachMark: `${API_ADMIN_PATH}user/increase-coach-mark`,
  //profile
  updateInformationName: `${API_ADMIN_PATH}user/update-information`,
  totalPieceCollected: `${API_ADMIN_PATH}mini-game/total-piece-collected`,
  //shwe-journey
  loginStreakStatus: `${API_ADMIN_PATH}login-streak/status`,
  loginStreakClaim: `${API_ADMIN_PATH}login-streak/claim`,
  loginStreakRevive: `${API_ADMIN_PATH}login-streak/revive`,
  loginStreakReset: `${API_ADMIN_PATH}login-streak/reset`,
  //Shwe-Vault
  shweVaultStatus: `${API_ADMIN_PATH}shwe-vault/status`,
  shweVaultOpen: `${API_ADMIN_PATH}shwe-vault/open`,
  //notification
  notifications: `${API_ADMIN_PATH}notification`,
  notificationsunreadCount: `${API_ADMIN_PATH}notification/unread-count`,
  notificationHide: `${API_ADMIN_PATH}notification/hide`,
  //rank
  userRankStatus: `${API_ADMIN_PATH}user-rank/status`,
  //loyalty-point
  loyaltyPoint: `${API_ADMIN_PATH}loyalty-point/wallet`,
  loyaltyPointWithdraw: `${API_ADMIN_PATH}loyalty-point/withdraw`,
  loyaltyPointHistory: `${API_ADMIN_PATH}loyalty-point/history`,
  //daily-reward
  dailyPrizeStatus: `${API_ADMIN_PATH}daily-prize/status`,
  dailyPrizeGuess: `${API_ADMIN_PATH}daily-prize/guess`,
  dailyPrizeHistory: `${API_ADMIN_PATH}daily-prize/history`,
  dailyPrizeGuesses: `${API_ADMIN_PATH}daily-prize/guess-history`,
  dailyPrizeGuessesAll: `${API_ADMIN_PATH}daily-prize/guesses`,
  dailyPrizePrizePool: `${API_ADMIN_PATH}daily-prize/prize-pool`,
};

export default API_PATH;
